import { IAssessment } from '@/entities';
import { AppConstants as _app} from '@/shared/app.constants';
import { IMutations } from './mutations.types';
// const temp = require('../dd_assessment_template_en.json');

export const mutations: IMutations = {
    /** set the selected review */
    setSelectedReview(state: IAssessment, payload: number): void {
        state.internalReviewId = payload
    },
    setTemplate(state: IAssessment, payload: any): void {
        state.templateList = payload
    },
    setViewAppTemplate(state: IAssessment, payload: any): void {
        state.applicationSection.templates = payload;
    },
    setViewAppData(state: IAssessment, payload: any): void {
        state.applicationSection.data = payload;
    },
    setReviewSections(state: IAssessment, payload: any): void {
        state.reviewSections = payload;
    },
    setViewAppHeader(state: IAssessment, payload: any): void {
        //Todo : Correct Application/ConceptNote data for review
        //state.applicationSection.appHeader = payload;
        if (payload.entity === 'ConceptNote') {
            state.applicationSection.appHeader = { ...payload.data, ApplicationId: payload.data.ConceptNoteId };
            delete state.applicationSection.appHeader.ConceptNoteId;
        }
        else {
            state.applicationSection.appHeader = payload.data;
        }
    },
    refreshTemplates(state: IAssessment) {
        if(state.templateList[state.language]){
            // state.usedTemplate = state.templateList[state.language];
            state.dueDeliganceAssessment.templates = state.templateList[state.language].properties[_app.assessmentWorkspace.default_menu];
            state.budgetAssessment.templates = state.templateList[state.language].properties[_app.assessmentWorkspace.budget];
            if(!state.dueDeliganceAssessment.selectedKey) {
                state.dueDeliganceAssessment.selectedKey = Object.keys(state.dueDeliganceAssessment.templates.properties)[0];
            }
        }
    },
    setLanguage(state: IAssessment, payload: string) {
        state.language = payload;
        state.applicationSection.language = payload;
    },
    /** re-assigning data */
    setAssessment(state: IAssessment, payload: any) {
        state.dueDeliganceAssessment = payload.dueDeliganceAssessment;
        state._id = payload._id;
        state.applicationId = payload.applicationId;
        state.internalReviewerId = payload.internalReviewerId;
        state.version = payload.version;
        state.status = payload.status;
        state.auditInfo = payload.auditInfo;
    },
    setActiveKey(state: IAssessment, payload: string) {
        state.dueDeliganceAssessment.selectedKey = payload;
    },
    setBudgetActiveKey(state: IAssessment, payload: string) {
        state.budgetAssessment.selectedKey = payload;
    },
    setDueDiligenceData(state: IAssessment, payload: any) {
        state.dueDeliganceAssessment.data = payload
    },
    setBudgetData(state: IAssessment, payload: any) {
        state.budgetAssessment.data = payload
    },
    setTabKey(state: IAssessment, payload: string) {
        state.selectedItem = payload;
    },
    setHeader(state: IAssessment, payload: any) {
        state.reviewHeader = payload;
    },
    resetActiveTab(state: IAssessment) {
        state.dueDeliganceAssessment.selectedKey = _app.assessmentWorkspace.default_dd_review_key;
        state.budgetAssessment.selectedKey = _app.assessmentWorkspace.default_budget_review_key;
        state.selectedItem = _app.assessmentWorkspace.default_menu;
    }
}